import { render } from "./Directory.vue?vue&type=template&id=35926bac&ts=true"
import script from "./Directory.vue?vue&type=script&lang=ts"
export * from "./Directory.vue?vue&type=script&lang=ts"

import "./Directory.vue?vue&type=style&index=0&id=35926bac&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__